import Marquee from "react-fast-marquee";

export const TextMarquee = ({
  items = ["Sports", "Events", "Experiences"],
  color = "#e62429",
  direction = "left",
  border = true,
}) => {
  return (
    <div
      data-testid="text-marquee"
      className={`w-full bg-[#0a0a0a] py-6 sm:py-8 overflow-hidden ${
        border ? "border-y border-white/10" : ""
      }`}
    >
      <Marquee speed={55} direction={direction} gradient={false}>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display uppercase text-4xl sm:text-6xl lg:text-7xl px-6 text-white">
              {item}
            </span>
            <span
              className="mx-3 h-3 w-3 rotate-45"
              style={{ backgroundColor: color }}
            />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
